import owd from 'owd/owd';
import 'lib/js.cookie';

export default class GDPR extends owd.Component {
	init() {
        //this.buttonDisagree = this.$element.find('.button--disagree');
        this.buttonAgree = this.$element.find('.button--close');
        
		this.bind();
	}
    
    hideModal() {
        this.$element.removeClass('is-visible');
        //this.dom.$body.removeClass('privacy');
    }

	bind() {
        this.on('load ajaxload', this.dom.$window, (e) => {
            if(Cookies.get('agreement-polsat-gdpr') === undefined) {
                this.$element.addClass('is-visible');
                //this.dom.$body.addClass('privacy');
            }
        });
        
        this.on('click', this.buttonAgree, (e) => {
            this.hideModal();
            
            Cookies.set('agreement-polsat-gdpr', "yes", { expires: 365, path: '/' });
        });
        
        /*this.on('click', this.buttonDisagree, (e) => {
            this.hideModal();
            
            Cookies.set('agreement-polsat-gdpr', "no", { expires: 7, path: '/' });
        });*/
    }

    destroy() {
        super.destroy();
    }
}

owd.registerComponent('gdpr', {
	component: GDPR
});
